function isRecord(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object';
}

export function extractErrorMessage(error: unknown, fallback: string): string {
  if (!error) {
    return fallback;
  }
  if (typeof error === 'string' && error.trim()) {
    return error;
  }

  if (isRecord(error)) {
    const {
      data,
      message,
      error: errorField,
      status,
    } = error as {
      data?: unknown;
      message?: unknown;
      error?: unknown;
      status?: unknown;
    };
    if (status === 'PARSING_ERROR') {
      if (typeof data === 'string' && data.trim()) {
        return data;
      }
      return fallback;
    }
    if (
      Array.isArray(data) &&
      data.length > 0 &&
      data.every((issue) => isRecord(issue) && typeof issue.message === 'string')
    ) {
      return data.map((issue) => issue.message as string).join('. ');
    }
    if (isRecord(data)) {
      if (typeof data.message === 'string') {
        return data.message;
      }
      if (typeof data.error === 'string') {
        return data.error;
      }
    }
    if (typeof data === 'string' && data.trim()) {
      return data;
    }
    if (typeof errorField === 'string' && errorField.trim()) {
      return errorField;
    }
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  return fallback;
}
